import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render() {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          d: "M12.7074 2.29298C12.3167 1.90234 11.6833 1.90234 11.2926 2.29298L8.20945 5.37585C7.81877 5.7665 7.81877 6.39986 8.20945 6.79051L11.2933 9.87405C11.684 10.2647 12.3174 10.2647 12.7081 9.87405L15.7913 6.79118C16.1819 6.40053 16.1819 5.76717 15.7913 5.37652L12.7074 2.29298Z",
          fill: "currentColor",
        }),
        _createElementVNode("path", {
          d: "M17.2071 8.20839C17.5978 7.81775 18.2312 7.81774 18.6219 8.20839L21.707 11.2932C22.0977 11.6838 22.0977 12.3172 21.707 12.7078L18.6226 15.7919C18.232 16.1825 17.5985 16.1825 17.2078 15.7919L14.1228 12.7071C13.7321 12.3165 13.7321 11.6831 14.1228 11.2925L17.2071 8.20839Z",
          fill: "currentColor",
        }),
        _createElementVNode("path", {
          d: "M12.7093 14.1242C12.3186 13.7336 11.6852 13.7336 11.2945 14.1242L8.20922 17.2092C7.81853 17.5999 7.81853 18.2332 8.20922 18.6239L11.2925 21.7069C11.6832 22.0976 12.3166 22.0976 12.7073 21.7069L15.7926 18.6219C16.1833 18.2313 16.1833 17.5979 15.7926 17.2073L12.7093 14.1242Z",
          fill: "currentColor",
        }),
        _createElementVNode("path", {
          d: "M5.37708 8.20888C5.76776 7.81823 6.40119 7.81823 6.79187 8.20888L9.87749 11.2942C10.2681 11.6849 10.2681 12.3182 9.87749 12.7089L6.79336 15.7927C6.40268 16.1834 5.76926 16.1834 5.37858 15.7927L2.29295 12.7074C1.90227 12.3167 1.90227 11.6834 2.29295 11.2927L5.37708 8.20888Z",
          fill: "currentColor",
        }),
      ],
    )
  );
};
